import { Injectable } from "@angular/core";
import { SsrCookieService } from "ngx-cookie-service-ssr";

interface CookieOptions {
  expires?: number | Date;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'Lax' | 'None' | 'Strict';
}

@Injectable()
export class UniversalStorage implements Storage {
  [index: number]: string;
  [key: string]: any;
  length: number = 0;
  cookies: any;

  cookieOptions = {
    path: '/',
    expires: new Date(Date.now() + 100 * 24 * 60 * 60 * 1000) // 100 days
  } as CookieOptions;

  constructor(protected readonly cookieService: SsrCookieService) { }

  public clear(): void {
    this.cookieService.deleteAll();
  }

  public getAll(): Object {
    return this.cookieService.getAll();
  }

  public getItem(key: string): string {
    return this.cookieService.get(key) ?? '';
  }

  public key(index: number): string {
    return Object.keys(this.cookieService.getAll())[index];
  }

  public removeItem(key: string): void {
    this.cookieService.delete(key,
      this.cookieOptions.path,
      this.cookieOptions.domain,
      this.cookieOptions.secure,
      this.cookieOptions.sameSite);
  }

  public setItem(key: string, data: string): void {
    if (key !== 'language.code') {
      return;
    }
    this.cookieService.set(key, data, this.cookieOptions);
  }

  public setItemFromObject<T>(key: string, item: T): void {
    this.setItem(key, JSON.stringify(item));
  }

  public getItemFromObject<T>(key: string): T | null {
    const value = this.getItem(key);

    if (value) {
      try {
        return JSON.parse(value) as T;
      }
      catch {
        return null;
      }
    }

    return null;
  }
}
